import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useIndustries = () => {
  const [industries, setIndustries] = useState([]);
  useEffect(() => {
    fetch(`${API}/industries`)
      .then((response) => response.ok ? response.json() : [])
      .then(setIndustries)
      .catch(() => setIndustries([]));
  }, []);
  return industries;
};